import { Body as BodyUI, MaterialUICore, tokens } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const Body = styled(BodyUI)({
  fontSize: tokens.font.size.xxs,
  color: tokens.color.neutral[500],
});
